<template>
  <div class="days">
    <a :class="{selected: selectedDay===null}"
       @click="$emit('selectAllDays')"
    >all</a>
    <a v-for="(day, dayNumber) in daysOfWeek"
       :class="{selected: dayNumber===selectedDay}"
       @click="$emit('selectDay', dayNumber)"
    >
      {{ day }}
    </a>
  </div>
</template>

<script>
export default {
  name: 'DayOfWeekPicker',

  data() {
    return {
      daysOfWeek: [ 'sun',  'mon',  'tue',  'wed',  'thu',  'fri',  'sat' ],
    }
  },

  props: {
    selectedDay: null,
  },

}
</script>

<style scoped>
  .days > a {
    color: #128ff9;
  }
  .days > a.selected {
    color: black;
  }
</style>
